import htmlToPdfmake from "html-to-pdfmake"
import {
    moduleIds,
    ModuleList,
    LangType,
} from "client/store"
import * as Const from "client/components/pdfmake/template/const"

const CopyrightPage = (
    moduleList: ModuleList,
    lang: LangType,
) => {
    // TODO: check copyright text
    const copyright = moduleList[moduleIds.cc].copyright || lang.noCopyright
    const copyrightConverted = htmlToPdfmake(copyright)

    /*
    return [{
        pageBreak: "before",
        margin: [0, 20, 0, 0],
        stack: copyrightConverted,
    }] as any[]
    */

    return [
        {
            pageBreak: "before",
            margin: [0, 540, 0, 0],
            bold: true,
            style: Const.COPYRIGHT,
            text: "© Copyright Risknowlogy® - All Rights Reserved.\n\n",
        },
        {
            style: Const.COPYRIGHT,
            text: "LIMITATION OF LIABILITY - This report was prepared using best efforts. Risknowlogy does not accept any "
            + "responsibility for omissions or inaccuracies in this report caused by the fact that certain information or "
            + "documentation was not made available to us. Any liability in relation to this report is limited to the indemnity "
            + "as outlined in our Terms and Conditions. A copy is available at all times upon request.\n\n",
        },
        {
            style: Const.COPYRIGHT,
            text: "This document is the property of, and is proprietary to Risknowlogy®. The client does not have the right to "
            + "disclose in whole or in part and no portion of this document shall be duplicated in any manner for any "
            + "purpose without Risknowlogy’s expressed written authorisation.",
        },
    ]
}
export default CopyrightPage
